<template>
  <sh-button
    color="secondary"
    aria-live="polite"
    :aria-label="copyTextLabel"
    @click="handleCopyCode"
  >
    {{ copyText }}
  </sh-button>
</template>

<script>
export default {
  props: {
    promotionCode: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      hasCopiedCode: false
    }
  },

  computed: {
    copyTextLabel () {
      return this.hasCopiedCode
        ? this.$t('COPY_TO_CLIPBOARD_COPIED_LABEL')
        : this.$t('PERKS_COPY_CODE_CTA_LABEL')
    },

    copyText () {
      return this.hasCopiedCode
        ? this.$t('COPY_TO_CLIPBOARD_COPIED')
        : this.$t('PERKS_COPY_CODE_CTA')
    }
  },

  methods: {
    async handleCopyCode () {
      await this.$copyText(this.promotionCode)
      this.hasCopiedCode = true
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
